var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.41 8.24325L14.58 3.41325C14.21 3.04325 13.7 2.83325 13.17 2.83325H6C4.9 2.83325 4.01 3.73325 4.01 4.83325L4 20.8333C4 21.9333 4.89 22.8333 5.99 22.8333H18C19.1 22.8333 20 21.9333 20 20.8333V9.66325C20 9.13325 19.79 8.62325 19.41 8.24325ZM14 8.83325C13.45 8.83325 13 8.38325 13 7.83325V4.33325L17.5 8.83325H14Z",
    fill: "#677380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.1d50a99d0a38f9417043b5252eec0504.svg";
export { ForwardRef as ReactComponent };